exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".solver-options {\r\n    padding:30px;\r\n    text-align:center;\r\n}\r\n\r\n.solver-options button {\r\n    margin-left: 20px;\r\n    margin-right:20px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/padriana/gorent-panel/src/app/dashboard/evaluation/evaluation-detail.component.css
// module id = ../../../../../src/app/dashboard/evaluation/evaluation-detail.component.css
// module chunks = main